import React from 'react';
import Dialog from '~/components/Dialog';
import { Button } from 'react-toolbox/lib/button';
import style from './style.scss';

export default props => (
  <Dialog {...props} className={`${style.container} ${props.className}`}>
    {props.children}
    <div className={style.buttons}>
      {props.onCancelClick && (
        <Button label="Cancel" raised onClick={props.onCancelClick} />
      )}
      {props.onOkClick && (
        <Button label="OK" raised primary onClick={props.onOkClick} />
      )}
    </div>
  </Dialog>
);



// WEBPACK FOOTER //
// ./app/components/ConfirmationDialog/index.js